
import Vue from 'vue'
import util from '@/libs/util'
import {_} from '@/libs/util'
import Auth from '@/libs/auth'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Msg from 'vux/src/components/msg/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import common from '@/libs/common.mixin'

const STUDENT_LOGIN_PARAMS = 'student_login_params'

export default {
mixins:[common],
components: {
XInput,
Group,
XButton,
Cell,
Msg,
Flexbox,
FlexboxItem
},
data () {
return {
error:'',
auto_login: true,
login:{
account:'',
password:''
}
}
},
computed:{
logo () {
let ui = window.CLIENT_PARAMS,
result = '/static/img/logo-2.jpg'
if(!_.isEmpty(ui)&&!_.isEmpty(ui.mobile)&&ui.mobile.logo!=''){
result = ui.mobile.logo
}
return result
},
isFormValid(){
let valid = true
let ereg = /^\s*$/
let mreg = /^1[\d]{10}$/
for(let key in this.login){
let value = this.login[key]
if(ereg.test(value)){
valid = false
break;
}
}
return valid
}
},
mounted () {
let	params = Vue.localStorage.get(STUDENT_LOGIN_PARAMS),
ui = window.CLIENT_PARAMS
if(!_.isEmpty(ui)&&!_.isEmpty(ui.mobile)&&ui.mobile.system_name!=''){
this.$store.commit('setSysName',ui.mobile.system_name)
}

if(params){
this.login = JSON.parse(params)

this.doLogin()
}else{
let openid = this.getUrlKey('openid')
if(openid && openid != ''){
this.$rest('open/openidLogin')
.get({
openid: openid
})
.success(res => {
Auth.setLocalLogin(res)
this.$router.push({ path: '/' })
})
.error(res => {
this.alert('',res.body.message)
})
}
}
},
methods:{
inputBlur() {
document.getElementById('login-layout').scrollIntoView({behavior: 'smooth',block:'start'})
},
focusAc() {
this.$refs.c1.focus()
},
focusPw() {
this.$refs.c2.focus()
},
toggleAutoLogin () {
this.auto_login = !this.auto_login
},
page(action){
this.action = action
},
backForm(){
this.page('form')
},
goReview(){
this.$store.commit('setSession',{name:'lapply',value:'success'})
this.$router.push('/lreview')
},
doLogin(){
this.$vux.loading.show({
text: '登录中'
})

this.$http.post('signin',this.login)
.then(response=>{
this.$vux.loading.hide()
Auth.setLocalLogin(response.body.data)

if(this.auto_login){
this.$store.commit('autoLogin',{
account: this.login.account,
password: this.login.password
})
}
this.$router.push({ path: '/' })

},response=>{
this.$vux.loading.hide()
let msg = response.body.message
let msg_map = {
'password_is_wrong':'密码错误',
'account_does_not_exists':'账号不存在',
'user_is_disabled':'账号被禁用'
}
msg = msg_map[msg]?msg_map[msg]:msg;
this.error = msg
})
}
}
}



// WEBPACK FOOTER //
// ./src/views/login.vue